import React, { useEffect, useState } from "react";
import "./style.css";
import Dropdowncustom from "../UI-Controls/Dropdown/dropdownaddgeneral1";
import { Url } from "../../Services/Api";

export default function PriceChangePopUp({
    showPriceChangePopup,
    productData,
    onClose,
    onUpdate
}) {

    const [variations, setVariations] = useState([]);
    const [originalVariations, setOriginalVariations] = useState([]);
    const [simpleProduct, setSimpleProduct] = useState(null);
    const [originalSimpleProduct, setOriginalSimpleProduct] = useState(null);
    const [isChanged, setIsChanged] = useState(false);

    const isVariable = productData?.type === "variable";

    const productStockOptions = [
        { value: "inStock", label: "In Stock" },
        { value: "outStock", label: "Out of Stock" },
    ];

    // Reset when popup closes
    useEffect(() => {
        if (!showPriceChangePopup) {
            setVariations([]);
            setOriginalVariations([]);
            setSimpleProduct(null);
            setOriginalSimpleProduct(null);
            setIsChanged(false);
        }
    }, [showPriceChangePopup]);

    // Initialize data
    useEffect(() => {

        if (isVariable && productData?.variations?.length > 0) {
            const cloned = JSON.parse(JSON.stringify(productData.variations));
            setVariations(cloned);
            setOriginalVariations(cloned);
        }

        if (!isVariable && productData) {
            const cloned = JSON.parse(JSON.stringify(productData)); // deep clone
            setSimpleProduct(cloned);
            setOriginalSimpleProduct(JSON.parse(JSON.stringify(cloned))); // independent copy
        }


        setIsChanged(false);

    }, [productData]);

    // ===============================
    // VARIABLE PRODUCT HANDLER
    // ===============================
    const handleVariationChange = (index, field, value) => {
        const updated = [...variations];

        if (field === "stock_status") {
            updated[index] = {
                ...updated[index],
                manage_stock: {
                    ...(updated[index].manage_stock || {}),
                    stock_status: value
                }
            };
        }
        else if (field === "quantity") {
            updated[index] = {
                ...updated[index],
                manage_stock: {
                    ...(updated[index].manage_stock || {}),
                    quantity: value
                }
            };
        }
        else {
            updated[index] = {
                ...updated[index],
                [field]: value
            };
        }

        setVariations(updated);

        // 🔥 Proper change detection
        const changed = updated.some((item, i) => {
            const original = originalVariations[i];

            return (
                item.sale_price !== original?.sale_price ||
                item.regular_price !== original?.regular_price ||
                item?.manage_stock?.stock_status !== original?.manage_stock?.stock_status ||
                item?.manage_stock?.quantity !== original?.manage_stock?.quantity
            );
        });

        setIsChanged(changed);
    };


    // ===============================
    // SIMPLE PRODUCT HANDLER
    // ===============================
    const handleSimpleChange = (field, value) => {
        const updated = { ...simpleProduct };

        // Ensure manage_stock exists
        if (!updated.manage_stock) updated.manage_stock = {};

        // Always store strings for input comparison
        if (field === "stock_status") {
            updated.manage_stock.stock_status = value || "";
        } else if (field === "quantity") {
            updated.manage_stock.quantity = value?.toString() || "";
        } else {
            updated[field] = value?.toString() || "";
        }

        setSimpleProduct(updated);

        // Normalize original manage_stock for comparison
        const originalStock = originalSimpleProduct?.manage_stock || {};
        console.log(originalStock, "originalSimpleProduct", updated.manage_stock, "updated")

        // Proper change detection
        const changed =
            (updated.sale_price?.toString() || "") !== (originalSimpleProduct?.sale_price?.toString() || "") ||
            (updated.regular_price?.toString() || "") !== (originalSimpleProduct?.regular_price?.toString() || "") ||
            (updated.manage_stock.stock_status || "") !== (originalStock.stock_status || "") ||
            (updated.manage_stock.quantity?.toString() || "") !== (originalStock.quantity?.toString() || "");

        setIsChanged(changed);
    };



    // ===============================
    // UPDATE
    // ===============================
    const handleUpdate = () => {

        if (isVariable) {

            const changedVariations = variations
                .filter((item, index) =>
                    JSON.stringify(item) !==
                    JSON.stringify(originalVariations[index])
                )
                .map(item => ({
                    uid: item?.uid,
                    _id: item?._id,
                    sale_price: item?.sale_price,
                    regular_price: item?.regular_price,
                    stock_status: item?.manage_stock?.stock_status,
                    stock_quantity: item?.manage_stock?.quantity
                }));

            const payload = {
                uid: productData?.uid,
                variations: changedVariations
            };
            console.log(payload, "here is pload")

            onUpdate && onUpdate(payload);
        }
        else {

            const payload = {
                uid: productData?.uid,
                sale_price: simpleProduct?.sale_price,
                regular_price: simpleProduct?.regular_price,
                stock_status: simpleProduct?.manage_stock?.stock_status,
                stock_quantity: simpleProduct?.manage_stock?.quantity
            };

            console.log(payload, "here is pload")

            onUpdate && onUpdate(payload);
        }
    };

    const handleClose = () => {
        setIsChanged(false);
        onClose && onClose();
    };

    return (
        <div className={
            showPriceChangePopup
                ? "price-change-modal-main-container show-price-change-prev-modal"
                : "price-change-modal-main-container"
        }>
            <div className={`price-prev-modal-inner-container ${showPriceChangePopup ? 'show-price-prev-inner-modal' : ''
                }`} style={{
                    height: productData?.type === 'simple' ? "350px" : "80vh"
                }}>
                <div className="product_details_ppmic_header">
                    <img src={Url + productData?.image?.image_url} alt="" srcset="" />
                    <div className="product_details_ppmic">
                        <h2>{productData?.name}</h2>
                        <p>SKU : {productData?.sku}</p>
                        <span>{productData?.type}</span>
                    </div>
                </div>


                <div className="variations_scroll_container">

                    {/* ================= VARIABLE ================= */}
                    {isVariable && variations?.map((item, index) => (
                        <div className="variation_block" key={item?.uid}>
                            {item?.is_default_variation === 1 && <div className="default_variation_block">
                                Default
                            </div>}
                            <h1>{item?.name}</h1>

                            <div className="variation_block_product_details">
                                <label className="field_v_b">
                                    <p>Sale Price</p>
                                    <div className="InputWrapper-Sale" style={{ width: "100%" }}>
                                        <span className="Prefix">$</span>
                                        <input
                                            className="Updated-Data-Field"
                                            type="text"
                                            value={item?.sale_price || ""}
                                            onChange={(e) =>
                                                handleVariationChange(index, "sale_price", e.target.value)
                                            }
                                        />
                                    </div>
                                </label>
                                <label className="field_v_b">
                                    <p>Regular Price</p>
                                    <div className="InputWrapper-Sale" style={{ width: "100%" }}>
                                        <span className="Prefix">$</span>
                                        <input
                                            className="Updated-Data-Field"
                                            type="text"
                                            value={item?.regular_price || ""}
                                            onChange={(e) =>
                                                handleVariationChange(index, "regular_price", e.target.value)
                                            }
                                        />
                                    </div>
                                </label>
                                <label className="field_v_b">
                                    <p>Stock Status</p>


                                    <Dropdowncustom
                                        options={productStockOptions}
                                        selected={item?.manage_stock?.stock_status}
                                        onChange={(value) =>
                                            handleVariationChange(index, "stock_status", value)
                                        }
                                        dropdownstyle={{
                                            fontSize: "12px",
                                            width: "100%"
                                        }}
                                    />
                                </label>
                                <label className="field_v_b">
                                    <p>Stock Quantity</p>

                                    <div className="InputWrapper-Sale" style={{ width: "100%" }}>
                                        <input
                                            className="Updated-Data-Field"
                                            type="text"
                                            value={item?.manage_stock?.quantity || ""}
                                            onChange={(e) =>
                                                handleVariationChange(index, "quantity", e.target.value)
                                            }
                                        />
                                    </div>
                                </label>

                            </div>
                        </div>
                    ))}

                    {/* ================= SIMPLE ================= */}
                    {!isVariable && simpleProduct && (
                        <div className="variation_block_product_details">
                            <label className="field_v_b">
                                <p>Sale Price</p>
                                <div className="InputWrapper-Sale" style={{ width: "100%" }}>
                                    <span className="Prefix">$</span>
                                    <input
                                        className="Updated-Data-Field"
                                        type="text"
                                        value={simpleProduct?.sale_price || ""}
                                        onChange={(e) =>
                                            handleSimpleChange("sale_price", e.target.value)
                                        }
                                    />
                                </div>
                            </label>
                            <label className="field_v_b">
                                <p>Regular Price</p>
                                <div className="InputWrapper-Sale" style={{ width: "100%" }}>
                                    <span className="Prefix">$</span>
                                    <input
                                        className="Updated-Data-Field"
                                        type="text"
                                        value={simpleProduct?.regular_price || ""}
                                        onChange={(e) =>
                                            handleSimpleChange("regular_price", e.target.value)
                                        }
                                    />
                                </div>
                            </label>
                            <label className="field_v_b">
                                <p>Stock Status</p>

                                <Dropdowncustom
                                    options={productStockOptions}
                                    selected={simpleProduct?.manage_stock?.stock_status}
                                    onChange={(value) =>
                                        handleSimpleChange("stock_status", value)
                                    }
                                    dropdownstyle={{
                                        fontSize: "12px",
                                        width: "100%"
                                    }}
                                />
                            </label>
                            <label className="field_v_b">
                                <p>Stock Quantity</p>

                                <div className="InputWrapper-Sale" style={{ width: "100%" }}>
                                    <input
                                        className="Updated-Data-Field"
                                        type="text"
                                        value={simpleProduct?.manage_stock?.quantity || ""}
                                        onChange={(e) =>
                                            handleSimpleChange("quantity", e.target.value)
                                        }
                                    />
                                </div>
                            </label>

                        </div>
                    )}

                </div>

                <div className="popup_footer">
                    <button className="close_btn" onClick={handleClose}>
                        Close
                    </button>

                    {isChanged && (
                        <button className="update_btn" onClick={handleUpdate}>
                            Update
                        </button>
                    )}
                </div>

            </div>
        </div>
    );
}
